module.exports = __webpack_public_path__ + "img/flamethrower-turret-gun-shadow.9a5931ec.png";